import { render, staticRenderFns } from "./dxjy.vue?vue&type=template&id=6562812a&scoped=true&"
import script from "./dxjy.vue?vue&type=script&lang=js&"
export * from "./dxjy.vue?vue&type=script&lang=js&"
import style0 from "./dxjy.vue?vue&type=style&index=0&id=6562812a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6562812a",
  null
  
)

export default component.exports